import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  OurValuesCard,
  OurValue,
} from '../../../../shared/components/our-values-card/our-values-card';
import { TranslationService } from '../../../../core/services/translation.service';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-about-our-values',
  imports: [CommonModule, OurValuesCard, TranslatePipe],
  templateUrl: './about-our-values.html',
  styleUrl: './about-our-values.scss',
})
export class AboutOurValues implements OnInit, OnDestroy {
  values: OurValue[] = [];
  private subscription = new Subscription();

  constructor(private translationService: TranslationService) {}

  ngOnInit() {
    this.subscription.add(
      this.translationService.translationsLoaded$.subscribe((loaded) => {
        if (loaded) {
          this.loadValues();
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private loadValues() {
    const t = this.translationService.t.bind(this.translationService);
    this.values = [
      {
        icon: 'fa-solid fa-shield-halved',
        title: t('about.values.transparency.title'),
        description: t('about.values.transparency.description'),
        gradientClass: 'bg-gradient-to-br from-blue-500 to-blue-600',
      },
      {
        icon: 'fa-solid fa-wand-magic-sparkles',
        title: t('about.values.innovation.title'),
        description: t('about.values.innovation.description'),
        gradientClass: 'bg-gradient-to-br from-purple-500 to-purple-600',
      },
      {
        icon: 'fa-solid fa-heart',
        title: t('about.values.trust.title'),
        description: t('about.values.trust.description'),
        gradientClass: 'bg-gradient-to-br from-red-500 to-red-600',
      },
      {
        icon: 'fa-solid fa-award',
        title: t('about.values.professionalism.title'),
        description: t('about.values.professionalism.description'),
        gradientClass: 'bg-gradient-to-br from-green-500 to-green-600',
      },
    ];
  }
}
